export const externalUserWaringStyles: React.CSSProperties = {
  marginTop: '20px',
  marginLeft: '24px',
  padding: '5px',
  width: '895px'
};
